import { render, staticRenderFns } from "./PedidoFracionado.vue?vue&type=template&id=13697154"
import script from "./PedidoFracionado.vue?vue&type=script&lang=js"
export * from "./PedidoFracionado.vue?vue&type=script&lang=js"
import style0 from "./PedidoFracionado.vue?vue&type=style&index=0&id=13697154&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports